import { Button } from '@/components/ui/button';
import { Copy } from 'lucide-react';
import { Invoice } from 'src/trpc';

export const InvoicePaymentLinkSection = ({
  invoice,
  onCopyCustomerLink,
}: {
  invoice: Invoice;
  onCopyCustomerLink: () => void;
}) => {
  return (
    <div className="card relative min-w-[400px] w-full flex flex-col gap-4 items-start">
      <div className="space-y-4 w-full">
        <div>
          <label className="label text-xs">Payment Link</label>
        </div>
        <div className="flex flex-row gap-2 justify-between w-full items-center">
          <a
            href={invoice.paymentLinkUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="text-sm text-muted underline break-all"
          >
            {invoice.paymentLinkUrl}
          </a>
          <Button
            variant="outline"
            size="sm"
            onClick={onCopyCustomerLink}
            className="flex items-center gap-2"
          >
            <Copy className="w-4 h-4" />
            Copy Link
          </Button>
        </div>
      </div>
    </div>
  );
};
